// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__lV0bQ","I":"Legend_I__F81nH","showMore":"Legend_showMore__ZYsX2","button":"Legend_button__oQHxD"};